export const size = {
  width: 1125,
  height: 2436,
};

export const textFrame = {
  x: 164,
  y: 623,
  width: 800,
  height: 800,
};

export const bookFrame = {
  x: 164,
  y: 1160,
  width: 800,
  height: 100,
};

export const fonts = [
  "Oswald",
  "Amatic SC",
  "Arima Madurai",
  "Bangers",
  "Dancing Script",
  "Imbue",
  "Lobster",
  "Montserrat",
  "Kanit",
  "Lora",
  "Signika",
].map((f) => ({
  value: f,
  label: f,
}));
